"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weightInputSchema = void 0;
exports.default = WeightInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const zod_1 = require("zod");
exports.weightInputSchema = zod_1.z.coerce
    .number()
    .int()
    .gt(0, 'Required')
    .min(10, 'Minimum weight is 10')
    .max(990, 'Maximum weight is 990');
function WeightInput({ label = 'Weight', name, required = true }) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({ type: "number", label: label, error: Boolean(error), helperText: error === null || error === void 0 ? void 0 : error.message, required: required }, field, { onChange: (e) => field.onChange(parseInt(e.target.value) || '') })));
}
//# sourceMappingURL=WeightInput.js.map